

















































































import { Component, PropSync, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue')
  }
})
export default class PdTabSettingModalQuantityInputGroup extends mixins(
  InputGroup
) {
  @PropSync('emgOn', { type: Number }) syncEmgOn!: number
  @PropSync('emgLow', { type: Number }) syncEmgLow!: number
  @PropSync('emgHight', { type: Number }) syncEmgHight!: number
  @PropSync('warnOn', { type: Number }) syncWarnOn!: number
  @PropSync('warnLow', { type: Number }) syncWarnLow!: number
  @PropSync('warnHight', { type: Number }) syncWarnHight!: number

  @Prop({ type: String, required: true }) title!: string
  @Prop({ type: String, required: true }) delimiterText!: string
  @Prop({ default: '' }) name!: string
  @Prop({ default: false }) error!: boolean
}
